export default __webpack_public_path__ + "static/media/penhole-bills_converted.c24e4e1d.jpg";